import { EnrichmentPipeSet, TrackerSharedConfigurations, TransformPipeSet } from '@pulse/common';
import { PipeHost } from '../pipe';

export class PipesFactory {
    constructor(
        private pipesHost: PipeHost,
        private config: TrackerSharedConfigurations,
    ) {}

    registerPipes() {
        const transformPipes: TransformPipeSet[] = this.config.transformPipes || [];
        const enrichmentPipes: EnrichmentPipeSet[] = this.config.enrichmentPipes || [];
        transformPipes.forEach((pipe) => this.pipesHost.registerTransformSet(pipe));
        enrichmentPipes.forEach((pipe) => this.pipesHost.registerEnrichmentSet(pipe));
    }
}
